import angular from 'angular';

import { PublicationListController } from './publications.controller';
import { PublicationService } from './publications.service';
import { PublicationEditController } from './publication-edit.controller';
import { PublicationScheduleController } from './publication-schedule.controller';
import { PublicationActionWithSiteSelectorController } from './publication-action-with-site-selector.controller';

angular
  .module('publication', [])
  .controller('PublicationListController', PublicationListController)
  .controller('PublicationEditController', PublicationEditController)
  .controller('PublicationScheduleController', PublicationScheduleController)
  .controller('PublicationActionWithSiteSelectorController', PublicationActionWithSiteSelectorController)
  .factory('PublicationFactory', PublicationService.PublicationFactory);
